"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _semanticUiReact = require("semantic-ui-react");

var _Fields = require("./Fields");

var _Fields2 = _interopRequireDefault(_Fields);

require("../../assets/css/components/form/SelectField.css");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectField = function (_React$Component) {
    _inherits(SelectField, _React$Component);

    function SelectField(props) {
        _classCallCheck(this, SelectField);

        var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));

        _this.onBlur = function (event) {
            if (_reactDom2.default.findDOMNode(_this.select)) {
                var value = !_this.props.multiple ? _reactDom2.default.findDOMNode(_this.select).querySelector('.text').innerText : _reactDom2.default.findDOMNode(_this.select).querySelectorAll('.ui.label');
                if (_this.props.multiple) {
                    value = [];
                    _reactDom2.default.findDOMNode(_this.select).querySelectorAll('.ui.label').forEach(function (a) {
                        return value.push(a.innerText);
                    });
                }
                _this.setState({
                    fieldClass: _this.getFieldValidation({
                        untouched: false,
                        touched: true,
                        valid: _this.isValid(value),
                        invalid: !_this.isValid(value)
                    })
                });
                if (_this.props.onBlur) _this.props.onBlur(event);
            }
        };

        _this.state = {
            value: _this.convertValue(_this.props.value),
            fieldClass: _this.getFieldValidation({
                untouched: true,
                touched: false,
                dirty: false,
                invalid: !_this.isValid(_this.props.value),
                valid: _this.isValid(_this.props.value),
                focused: false
            })
        };

        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);

        return _this;
    }

    _createClass(SelectField, [{
        key: "convertValue",
        value: function convertValue(value) {
            if (value === true || value === false) {
                return value.toString();
            }
            return value;
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== undefined && nextProps.value !== null) {
                this.setState({
                    value: this.convertValue(nextProps.value),
                    fieldClass: this.getFieldValidation({
                        untouched: this.state.untouched,
                        touched: this.state.touched,
                        valid: this.isValid(nextProps.value),
                        invalid: !this.isValid(nextProps.value)
                    })
                });
            }
        }
    }, {
        key: "isValid",
        value: function isValid(value) {
            if (this.props.required) {
                return this.isOption(value);
            } else return true;
        }
    }, {
        key: "isOption",
        value: function isOption(value) {
            var _this2 = this;

            if (value) {
                var option = this.props.options.filter(function (o) {
                    if (_this2.props.multiple) {
                        return value.includes(o.value) || value.includes(o.text);
                    } else {
                        if (!_this2.props.multiple && value) return o.text === value || o.value === value || o.text === value.toString() || o.value === value.toString();
                    }
                });
                return option.length >= 1;
            }
            return false;
        }
    }, {
        key: "getClass",
        value: function getClass() {
            var estilo = "md-input border-bottom-primary";
            if (this.props.icon) estilo = estilo + " md-input-icon-" + (this.props.iconPosition || "left");
            return estilo;
        }
    }, {
        key: "getFieldValidation",
        value: function getFieldValidation(state) {
            var estilo = this.props.className ? this.props.className : "";
            if (state.touched) estilo = estilo + " touched";
            if (state.untouched) estilo = estilo + " untouched";
            if (state.dirty) estilo = estilo + " dirty";
            if (state.valid) estilo = estilo + " valid";
            if (state.invalid) estilo = estilo + " invalid";
            if (state.focused) estilo = estilo + " focused";
            if (this.props.required) estilo = estilo + " md-input-icon validate";
            return estilo;
        }
    }, {
        key: "onFocus",
        value: function onFocus() {
            this.setState({
                fieldClass: this.getFieldValidation({
                    untouched: false,
                    touched: true,
                    focused: true,
                    valid: this.isValid(this.state.value),
                    invalid: !this.isValid(this.state.value)
                })
            });
            if (this.props.onFocus) this.props.onFocus();
        }
    }, {
        key: "getClearButton",
        value: function getClearButton() {
            if (this.props.onClear) return _react2.default.createElement(
                "button",
                { id: this.props.name, className: "select-clear-button", type: "button",
                    onClick: this.props.onClear, title: "Limpar Campo" },
                _react2.default.createElement(_Icone2.default, { icone: "close" })
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _Fields2.default,
                { className: this.state.fieldClass, width: this.props.width, required: this.props.required,
                    icon: this.props.icon,
                    name: this.props.name, label: this.props.label,
                    validateMessage: this.props.validateMessage || this.props.invalidMessage,
                    ref: function ref(input) {
                        return _this3.select = input;
                    }, phoneWidth: this.props.phoneWidth,
                    tabletWidth: this.props.tabletWidth },
                _react2.default.createElement(_semanticUiReact.Select, { options: this.props.options, className: this.props.onClear ? "select-clear" : "",
                    label: this.props.label, name: this.props.name,
                    value: this.state.value, onChange: this.props.onChange,
                    placeholder: this.props.placeholder || 'Selecione uma opção',
                    required: this.props.required, onFocus: this.onFocus,
                    onBlur: this.onBlur, noResultsMessage: "N\xE3o encontrado", search: this.props.search,
                    selection: this.props.selection, fluid: this.props.fluid,
                    multiple: this.props.multiple, disabled: this.props.disabled,
                    id: this.props.id }),
                this.getClearButton()
            );
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this4 = this;

            var input = _reactDom2.default.findDOMNode(this.select).querySelector('input.search');
            if (input) {
                input.removeAttribute('tabindex');
                if (this.props.search && this.props.onKeyUp) input.addEventListener('keyup', function (event) {
                    _this4.props.onKeyUp(event, event.target);
                });
            }
            if (this.props.required) {
                var select = _reactDom2.default.findDOMNode(this.select).querySelector('select');

                if (select) {
                    select.removeAttribute('type');
                    select.required = this.props.required;
                }
            }
        }
    }]);

    return SelectField;
}(_react2.default.Component);

exports.default = SelectField;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/SelectField.js
// module id = 587
// module chunks = 0